import React from "react";

class AnimatedLogo extends React.Component {
  state = {
    intervalId: null,
    activeColor: null,
    colors: [
      "#000024",
      "#288ffe",
      "#0076f4",
      "#54c458",
      "#f5a623",
      "#e91e63",
      "#3f51b5",
      "#607d8b"
    ]
  };
  timerId = null;
  componentDidMount() {
    const colorCount = this.state.colors.length;
    const { colors } = this.state;

    let colorIndex = Math.floor(Math.random() * colorCount);

    this.setState({ activeColor: colors[colorIndex] });

    this.timerId = setInterval(() => {
      let colorIndex = Math.floor(Math.random() * colorCount);
      this.setState({ activeColor: colors[colorIndex] });
    }, 1600);
  }
  componentWillUnmount() {
    clearInterval(this.timerId);
  }
  render() {
    return (
      <div
        style={{
          width: "36px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <div
          className="animateWidth"
          style={{
            width: "100%",
            height: "2px",
            margin: 3,
            background: this.state.activeColor
          }}
        ></div>
      </div>
    );
  }
}

export { AnimatedLogo };
